import React, { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface QlfPageErrorBoundaryProps {
  children: ReactNode;
}

export function QlfPageErrorBoundary({ children }: QlfPageErrorBoundaryProps) {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <QlfPlaceholder primaryText={t('error.title')} secondaryText={t('error.page')} />
      )}
      resetKeys={[location]}
    >
      {children}
    </ErrorBoundary>
  );
}
